import React from 'react'
import { Link } from 'react-router-dom'

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  href, 
  to, 
  external = false,
  disabled = false,
  className = '',
  onClick,
  ...props 
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-semibold rounded-full transition-all duration-300 transform focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed'
  //const baseClasses = 'inline-flex items-center justify-center font-semibold rounded-lg transition-all duration-300 transform focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed'
  
  const variants = {
    primary: 'bg-gardenia-red hover:bg-red-700 text-white shadow-lg hover:shadow-xl focus:ring-gardenia-red hover:scale-105',
    secondary: 'bg-gardenia-green hover:bg-green-700 text-white shadow-lg hover:shadow-xl focus:ring-gardenia-green hover:scale-105',
    outline: 'border-2 border-gardenia-red text-gardenia-red hover:bg-gardenia-red hover:text-white focus:ring-gardenia-red',
    'outline-white': 'border-2 border-white text-white hover:bg-white hover:text-gardenia-red active:bg-white active:text-gardenia-red focus:ring-white',
    ghost: 'text-gardenia-red hover:bg-gardenia-gold/20 focus:ring-gardenia-red',
    gold: 'bg-gardenia-gold text-gardenia-dark hover:bg-yellow-300 shadow-lg hover:shadow-xl focus:ring-gardenia-gold hover:scale-105'
  }
  
  const sizes = {
  sm: 'px-5 py-2 text-sm',
  md: 'px-7 py-2.5 text-base',
  lg: 'px-9 py-3 text-lg',
  xl: 'px-11 py-3.5 text-xl'
}

  /*const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  }*/
  
  const classes = `${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`
  
  // Si es un enlace externo
  if (href && external) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={classes}
        {...props}
      >
        {children}
      </a>
    )
  }
  
  // Si es un enlace interno con React Router
  if (to) {
    return (
      <Link
        to={to}
        className={classes}
        {...props}
      >
        {children}
      </Link>
    )
  }
  
  // Si es un enlace normal
  if (href) {
    return (
      <a
        href={href}
        className={classes}
        {...props}
      >
        {children}
      </a>
    )
  }
  
  // Si es un botón normal
  return (
    <button
      className={classes}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  )
}

export default Button